export const getPopoverStyle = (isPopoverOpen: boolean, currentRange?: Range) => {
    if (!currentRange || !isPopoverOpen) {
        return undefined;
    }

    const editorElementWidth = document?.getElementsByClassName('structured-content-editor')?.[0]?.clientWidth;

    return {
        width: editorElementWidth,
    };
};
